import React from 'react';
import './AuthLayout.css';

/**
 * AuthLayout — minimal pass-through shell for the login/auth screens.
 * The auth pages (e.g. LoginPage) own their own background + branding,
 * so this layout deliberately doesn't add a Header or extra card wrapper.
 */
const AuthLayout = ({ children }) => (
  <div className="auth-layout">{children}</div>
);

export default AuthLayout;
